import * as Yup from 'yup';

import moment from 'moment';

export function isBeforeThanStartOrigin(value) {
  if (value.startSchedule && value.date) {
    const startDate = moment(value.startSchedule, 'YYYY-MM-DDTHH:mm');
    const endDate = moment(value.date, 'YYYY-MM-DDTHH:mm');
    return startDate.isBefore(endDate);
  }
  return true;
}

export function isStartOriginAValidDate(value) {
  if (value && !moment(value, 'YYYY-MM-DDTHH:mm', true).isValid()) {
    return false;
  }
  return true;
}

export function isEndOriginAValidDate(value) {
  if (value && !moment(value, 'YYYY-MM-DDTHH:mm', true).isValid()) {
    return false;
  }
  return true;
}

// Destinations

export function isBeforeThanStartDest(value) {
  if (value.start_schedule && value.scheduled_time) {
    const startDate = moment(value.start_schedule, 'YYYY-MM-DDTHH:mm');
    const endDate = moment(value.scheduled_time, 'YYYY-MM-DDTHH:mm');
    return startDate.isBefore(endDate);
  }
  return true;
}

export function isStartDestAValidDate(value) {
  if (value && !moment(value, 'YYYY-MM-DDTHH:mm', true).isValid()) {
    return false;
  }
  return true;
}

export function isEndDestAValidDate(value) {
  if (value && !moment(value, 'YYYY-MM-DDTHH:mm', true).isValid()) {
    return false;
  }
  return true;
}

export function isDateInMoreThanMinutesFromNow(minutes, date) {
  const dateInformed = moment(date, 'YYYY-MM-DDTHH:mm');
  const minimumDate = moment().add(minutes, 'minutes');
  return !date || dateInformed.diff(minimumDate) > 0;
}

export const DataSchema = Yup.object().shape({
  loadCreationNumber: Yup.number().required('Campo obrigatório'),
  taker: Yup.object()
    .required('Cliente Tomador obrigatório')
    .typeError('Cliente Tomador obrigatório'),
  costCenter: Yup.object()
    .required('Centro de custo obrigatório')
    .typeError('Centro de custo inválido'),
  isTracked: Yup.boolean()
    .required('Campo obrigatório')
    .typeError('Campo obrigatório'),
  riskManager: Yup.object().when('isTracked', {
    is: true,
    then: () => Yup.object()
      .required('Gerenciadora de risco obrigatória')
      .typeError('Gerenciadora de risco obrigatória'),
    otherwise: () => Yup.object().nullable(),
  }),
  dueDate: Yup.string()
    .test('not-empty', 'Informe uma data', (value) => {
      if (!value) {
        return false;
      }
      return true;
    })
    .test('valid-date', 'Formato inválido', (value) => {
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value);
    })
    .test('valid-future-date', 'Data não pode ser anterior/igual à data de hoje', (value) => {
      if (!value) {
        return false;
      }

      const inputDate = new Date(value);
      const currentDate = new Date();
      return inputDate > currentDate;
    }),
  vehicleTypes: Yup.array()
    .of(Yup.object())
    .required('Selecione pelo menos um veículo!')
    .min(1, 'Selecione pelo menos um veículo!'),
  vehicleBodies: Yup.array()
    .nullable()
    .required('Selecione pelo menos um tipo de carroceria!')
    .of(Yup.object())
    .min(1, 'Selecione pelo menos um tipo de carroceria!'),
  vehicleImplements: Yup.mixed().when('vehicleTypes', {
    is: value => Array.isArray(value) && value.filter(e => e.id === 18).length > 0,
    then: () => Yup.array()
      .min(1, 'Selecione pelo menos um implemento!')
      .typeError('Selecione pelo menos um implemento!'),
    otherwise: () => Yup.mixed(),
  }),
  searchDriverRadius: Yup.string().when('searchDriver', {
    is: true,
    then: () => Yup.string()
      .required('Informe um valor de raio')
      .max(500)
      .transform(value => {
        if (!value) {
          return undefined;
        }
        return value;
      }),
    otherwise: () => Yup.string().nullable(),
  }),
  origin: Yup.object()
    .shape({
      cityModel: Yup.object()
        .required('Cidade obrigatória')
        .typeError('Cidade obrigatória'),
      province: Yup.string()
        .required('UF obrigatório')
        .typeError('UF obrigatório'),
      date: Yup.string()
        .required('Data máxima obrigatória')
        .typeError('Data máxima obrigatória')
        .test('is-end-a-valid-date', 'Data máxima da coleta inválida', (value) =>
          isEndOriginAValidDate(value),
        )
        .test(
          'is-end-date-more-than-30-mins-from-now',
          'Data máxima da coleta precisa ser no mínimo daqui a 30 minutos',
          (value) => isDateInMoreThanMinutesFromNow(30, value),
        ),
      country: Yup.object()
        .required('País obrigatório')
        .typeError('País inválido'),
      lat: Yup.number()
        .required('Selecione um logradouro utilizando o seletor do google')
        .transform((currentValue, originalValue) => {
          return originalValue === '' ? undefined : currentValue;
        }),

      lng: Yup.number()
        .required('Selecione um logradouro utilizando o seletor do google')
        .transform((currentValue, originalValue) => {
          return originalValue === '' ? undefined : currentValue;
        }),
      startSchedule: Yup.string()
        .required('Data início obrigatória')
        .typeError('Data início inválida')
        .test('is-start-a-valid-date', 'Data de início inválida', value =>
          isStartOriginAValidDate(value)
        )
        .test(
          'is-end-date-more-than-30-mins-from-now',
          'Data máxima da coleta precisa ser no mínimo daqui a 30 minutos',
          value => isDateInMoreThanMinutesFromNow(30, value)
        )
    })
    .test(
      'is-before-than-start-schedule',
      'Data início da coleta não pode ser maior que Data máxima da coleta',
      (value) => isBeforeThanStartOrigin(value),
    ),

  destinations: Yup.array().of(
    Yup.object()
      .shape({
        cityModel: Yup.object()
          .required('Cidade obrigatória')
          .typeError('Cidade inválida'),
        province: Yup.string()
          .required('Estado obrigatório')
          .typeError('Estado inválido'),
        date: Yup.string()
          .required('Data máxima obrigatória')
          .typeError('Data máxima inválida')
          .test('is-end-a-valid-date', 'Data máxima inválida', (value) =>
            isEndDestAValidDate(value),
          )
          .test(
            'is-end-date-more-than-30-mins-from-now',
            'Data máxima precisa ser no mínimo daqui a 30 minutos',
            (value) => isDateInMoreThanMinutesFromNow(30, value),
          ),
        type: Yup.object()
          .required('Ação obrigatório')
          .typeError('Ação inválida'),
        country: Yup.object()
          .required('País obrigatório')
          .typeError('País inválido'),
        lat: Yup.number()
          .required('Selecione um logradouro utilizando o seletor do google')
          .transform((currentValue, originalValue) => {
            return originalValue === '' ? undefined : currentValue;
          }),
        lng: Yup.number()
          .required('Selecione um logradouro utilizando o seletor do google')
          .transform((currentValue, originalValue) => {
            return originalValue === '' ? undefined : currentValue;
          }),
        startSchedule: Yup.string()
          .required('Data início obrigatória')
          .typeError('Data início inválida')
          .test('is-start-a-valid-date', 'Data de início inválida', isStartDestAValidDate)
          .test(
            'is-start-schedule-more-than-30-mins-from-now',
            'Data início precisa ser no mínimo daqui a 30 minutos',
            value => isDateInMoreThanMinutesFromNow(30, value)
          )
      })
      .test(
        'is-before-than-start-schedule',
        'Data início não pode ser maior que Data máxima',
        (value) => isBeforeThanStartDest(value),
      ),
  ),
});

export const PreLoadDataSchema = Yup.object().shape({
  taker: Yup.object()
    .required('Cliente Tomador obrigatório')
    .typeError('Cliente Tomador obrigatório'),
  costCenter: Yup.object()
    .required('Centro de custo obrigatório')
    .typeError('Centro de custo inválido'),
  currency: Yup.object().required('Moeda obrigatória'),
  isTracked: Yup.boolean()
    .required('Campo obrigatório')
    .typeError('Campo obrigatório'),
  riskManager: Yup.object().when('isTracked', {
    is: true,
    then: () => Yup.object()
      .required('Gerenciadora de risco obrigatória')
      .typeError('Gerenciadora de risco obrigatória'),
    otherwise: () => Yup.object().nullable(),
  }),
  dueDate: Yup.string()
    .nullable()
    .required('Informe uma data')
    .transform((original) => {
      if (!original) {
        return undefined;
      }
      return original;
    })
    .test({
      name: 'dueDate',
      test(value, ctx) {
        if (!value) {
          return ctx.createError({ message: 'Informe uma data!' });
        }
        const isValidDate =
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value) ||
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(value);
        if (!isValidDate) {
          return ctx.createError({ message: 'Formato inválido' });
        }
        const inputDate = moment(value, 'YYYY-MM-DDTHH:mm');
        const currentDate = moment(new Date(), 'YYYY-MM-DDTHH:mm');
        if (inputDate.isBefore(currentDate)) {
          return ctx.createError({
            message: 'Data não pode ser anterior/igual à data de hoje',
          });
        }
        return true;
      },
    }),
});

export const VehicleDataSchema = Yup.object().shape({
  vehicleTypes: Yup.array().of(Yup.object()).min(1, 'Selecione pelo menos um veículo!'),
  vehicleBodies: Yup.array()
    .nullable()
    .required('Selecione pelo menos um tipo de carroceria!')
    .of(Yup.object())
    .min(1, 'Selecione pelo menos um tipo de carroceria!'),
  vehicleImplements: Yup.mixed().when('vehicleTypes', {
    is: value => Array.isArray(value) && value.filter(e => e.id === 18).length > 0,
    then: () => Yup.array()
      .min(1, 'Selecione pelo menos um implemento!')
      .typeError('Selecione pelo menos um implemento!'),
    otherwise: () => Yup.mixed(),
  }),
});
